import store from '@/store'
import vuetify from '@/plugins/vuetify'

const excludedErrors = [
  'You should assign a designer to move the order on that status'
]

const interceptorLoad = async (app) => {
  if (store.getters['company/getCurrencies']().length === 0) {
    const currency = await app.$api.currency.list({})
    store.dispatch('company/setCurrencies', currency.data)
  }

  let lang =
    localStorage.getItem('locale') != undefined
      ? localStorage.getItem('locale')
      : navigator.language.split('-')[0]

  window.axios.defaults.headers['Accept-Language'] = lang
  // add interceptor in axios for capture errors and emit notifications
  window.axios.interceptors.response.use(
    (response) => {
      if (store.getters['utils/getIsloading']) {
        store.dispatch('utils/actionLoading')
      }
      if (response.data?.emailTemplate?.warning === 'email_template_required') {
        app.$toast.warning(app.$t('email_template_required'))
      }
      return response
    },
    async (error) => {
      if (store.getters['utils/getIsloading']) {
        store.dispatch('utils/actionLoading')
      }
      const responseCode =
        error.response?.data?.code || error.response?.data?.detail
      const licenseSuspended = responseCode === 'license_suspended'
      if (licenseSuspended && error.config?.skipErrorToast) {
        return Promise.reject(error)
      }
      if (licenseSuspended) {
        app.$toast.error(app.$t('license_account_suspended'))
        if (localStorage.getItem('token') != null) {
          const refresh = localStorage.getItem('refresh_token')
          app.$api.auth.logout({ refresh_token: refresh })
          store.dispatch('session/logout')
          app.$router.push({ name: 'auth-login' })
        }
      } else if (responseCode === 'whatsapp_addon_disabled') {
        // La empresa dejó de tener el complemento mientras alguien tenía el
        // módulo abierto. No es un error para mostrarle: se limpia el estado
        // —la guarda de ruta lo vuelve a pedir— y se la lleva a la pantalla que
        // ofrece el complemento. Sin esto salían dos avisos rojos, uno de ellos
        // con el código crudo en pantalla.
        store.commit('whatsapp/setEntitlement', null)
        if (app.$route && app.$route.name !== 'whatsapp-upgrade') {
          app.$router.push({ name: 'whatsapp-upgrade' })
        }
      } else if (error.response != undefined && 401 === error.response.status) {
        if (localStorage.getItem('token') != null) {
          const refresh = localStorage.getItem('refresh_token')
          app.$toast.error(app.$t('expired'))
          app.$api.auth.logout({ refresh_token: refresh })
          store.dispatch('session/logout')
          app.$router.push({ name: 'auth-login' })
        }
      } else if (!error.config || !error.config.skipErrorToast) {
        let errors = error.response.data

        // Handle blob responses (e.g. failed PDF downloads)
        if (errors instanceof Blob) {
          const text = await errors.text()
          try {
            errors = JSON.parse(text)
          } catch (e) {
            app.$toast.error(text)
            return Promise.reject(error)
          }
        }

        var msg = ''
        const translate = (str) => (app.$te && app.$te(str) ? app.$t(str) : str)
        // Load messages in a text for show messages
        if (typeof errors === 'string') {
          //console.log('is string?')
          msg += `<li>${translate(errors)}</li>`
          if (!excludedErrors.includes(errors)) {
            app.$toast.error(msg)
          }
        } else {
          for (let err in errors) {
            if (errors.length > 1) {
              if (typeof errors[err] === 'string') {
                msg += `<li>${translate(errors[err])}</li>`
              } else {
                for (let msgs in errors[err]) {
                  if (typeof errors[err][msgs] === 'string') {
                    msg += `<li>${translate(errors[err][msgs])}</li>`
                  } else {
                    for (let i in errors[err][msgs]) {
                      msg += `<li>${translate(errors[err][msgs][i])}</li>`
                    }
                  }
                }
              }
            } else {
              msg += `<span>${translate(errors[err])}</span>`
            }
            app.$toast.error(msg)
          }
        }
      }
      return Promise.reject(error)
    }
  )
}

const updateColors = (getters) => {
  let colors = getters['company/getCompanyData']
  if (colors === undefined) {
    colors = {}
  }
  if (colors.primary_color === undefined) {
    colors.primary_color = '#34495e'
  }

  if (colors.secondary_color === undefined) {
    colors.secondary_color = '#345d48'
  }

  const darkMode = getters['session/darkMode']
  var tinycolor = require('tinycolor2')
  const darkText = tinycolor(colors.primary_color).isDark()
  const root = document.documentElement
  //  Set new colors
  root.style.setProperty('--primary', colors.primary_color)
  root.style.setProperty('--secundary', colors.secondary_color)
  root.style.setProperty('--text-color', darkText ? '#fff' : '#000')
  vuetify.theme.darkMode = darkMode
  vuetify.theme.themes.light.primary = colors.primary_color
  vuetify.theme.themes.dark.primary = colors.primary_color
  vuetify.theme.themes.light.secondary = colors.secondary_color
  vuetify.theme.themes.dark.secondary = colors.secondary_color
}

export { interceptorLoad, updateColors }
